import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";
import { InfraAIWordmark } from "@/components/InfraAIWordmark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (sessionStorage.getItem("infraai_logged_in") === "true") {
      nav("/admin/dashboard");
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${API}/admin/login`,
        { email, password },
        { withCredentials: true }
      );
      // Token is stored in httpOnly cookie by the server — never touches JS
      sessionStorage.setItem("infraai_logged_in", "true");
      sessionStorage.setItem("infraai_admin_email", data.email);
      toast.success("Welcome back");
      nav("/admin/dashboard");
    } catch (err) {
      if (err?.response?.status === 429) {
        toast.error("Çok fazla deneme. 60 saniye bekleyin.");
      } else {
        const msg = err?.response?.data?.detail || "Login failed";
        toast.error(typeof msg === "string" ? msg : "Login failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg grid place-items-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 border border-line bg-bg-paper mb-5">
            <Lock size={18} className="text-cyan" />
          </div>
          <h1 className="font-heading text-3xl tracking-tight">
            <InfraAIWordmark variant="inline" /> · Admin
          </h1>
          <p className="text-ink-mute text-sm mt-2 font-mono">
            Operator console · restricted access
          </p>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="border border-line bg-bg-paper/60 p-8 space-y-5"
        >
          <label className="block">
            <span className="block font-mono text-[10px] tracking-widest2 text-ink-mute uppercase mb-2">
              Email
            </span>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="w-full bg-bg border border-line text-ink px-4 py-3 text-sm font-body outline-none focus:border-cyan transition-colors"
              placeholder="admin@infraai.com"
            />
          </label>
          <label className="block">
            <span className="block font-mono text-[10px] tracking-widest2 text-ink-mute uppercase mb-2">
              Password
            </span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="w-full bg-bg border border-line text-ink px-4 py-3 text-sm font-body outline-none focus:border-cyan transition-colors"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-cyan text-black font-mono text-[12px] tracking-widest2 uppercase py-3.5 hover:bg-cyan-light disabled:opacity-50 transition-colors inline-flex items-center justify-center gap-2"
          >
            {loading ? "Signing in…" : "Sign in"}
            {!loading && <ArrowRight size={14} />}
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="font-mono text-[11px] text-ink-dim hover:text-ink transition-colors">
            ← Back to site
          </a>
        </div>
      </div>
    </div>
  );
}
